import { handleActions } from 'redux-actions';
import { DamzState } from '../../types';
import {
  hydrateStorage,
  saveEnterHandling,
  saveGoodState,
} from '../actions/storage';

export default handleActions<DamzState['storage'], any>(
  {
    [`${hydrateStorage}`]: (
      state,
      action: ReturnType<typeof hydrateStorage>
    ) => ({
      ...state,
      ...action.payload.store,
    }),
    [`${saveEnterHandling}`]: (
      state,
      action: ReturnType<typeof saveEnterHandling>
    ) => ({
      ...state,
      enterHandling: action.payload.handling,
    }),
    [`${saveGoodState}`]: (
      state,
      action: ReturnType<typeof saveGoodState>
    ) => ({
      ...state,
      canConnectToDamz: Date.now(),
    }),
  },
  {
    enterHandling: 'send',
    canConnectToDamz: undefined,
  }
);
